import { getErrorDetail } from "components/utility/utils";
import { fetchOrchidAPI } from "utils/api";

const completeZoomOAuth = async (
  authCode: string,
  codeVerifier: string,
): Promise<void> => {
  const res = await fetchOrchidAPI(`/api/users/v1/zoom/complete_oauth`, {
    method: "POST",
    body: JSON.stringify({
      code_verifier: codeVerifier,
      code: authCode,
    }),
  });

  if (!res.ok) {
    const responseText = await res.text();
    throw new Error(
      `Failed to successfully complete request: ${getErrorDetail(
        responseText,
      )}`,
    );
  }
  return;
};

export default completeZoomOAuth;
